module.exports = __webpack_public_path__ + "files/e3e97913deb1883d74e984b222714f9f.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/mattermost_dark.png
// module id = 704
// module chunks = 27